export const BOOL = "bool";
export const NUMBER = "number";
export const ARRAY = "array";
export const STRING = "string";
export const DATE = "date";